// Ghi chú riêng cho TỪNG bot (nút "Ghi chú" trên thẻ bot, 06/10/2026): quy tắc kiểm chữ DÙNG CHUNG cho máy chủ (PUT /api/bots/:id/ghi-chu) và
// trang web (hộp Ghi chú báo vượt giới hạn trước khi gửi) — một nơi định nghĩa để hai phía không lệch nhau.
// Quy tắc: bắt buộc là chuỗi; đổi xuống dòng kiểu Windows/Mac về "\n"; bỏ ký tự điều khiển (trừ xuống dòng và Tab); cắt khoảng trắng đầu/cuối;
// đếm theo KÝ TỰ THẬT (emoji = 1, không phải 2 như độ dài UTF-16); tối đa 2000 ký tự — dài hơn thì TỪ CHỐI (không cắt lặng lẽ làm mất chữ).
export const GHI_CHU_TOI_DA = 2000;

export type KetQuaGhiChu = { ok: true; noiDung: string } | { ok: false; loi: string };

/** Số ký tự thật của chuỗi (emoji, chữ có dấu tổ hợp… tính theo điểm mã Unicode). */
export const demKyTu = (s: string): number => Array.from(s).length;

/** Chuẩn hoá + kiểm ghi chú. Chuỗi rỗng (sau khi cắt) là HỢP LỆ: nghĩa là xoá ghi chú. */
export function chuanHoaGhiChu(v: unknown): KetQuaGhiChu {
  if (typeof v !== "string") return { ok: false, loi: "Ghi chú phải là chữ" };
  // eslint-disable-next-line no-control-regex
  const s = v.replace(/\r\n?/g, "\n").replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "").trim();
  const n = demKyTu(s);
  if (n > GHI_CHU_TOI_DA) return { ok: false, loi: `Ghi chú dài ${n} ký tự — tối đa ${GHI_CHU_TOI_DA} ký tự` };
  return { ok: true, noiDung: s };
}

/** Dòng xem trước ngắn 1 dòng cho thẻ bot: dòng không rỗng đầu tiên, gộp khoảng trắng, cắt theo ký tự thật + "…". Rỗng → "". */
export function xemTruocGhiChu(noiDung: string | null | undefined, toiDa = 48): string {
  if (!noiDung) return "";
  const dong = noiDung.split("\n").map((d) => d.replace(/\s+/g, " ").trim()).find((d) => d !== "") ?? "";
  const ky = Array.from(dong);
  return ky.length > toiDa ? `${ky.slice(0, Math.max(1, toiDa - 1)).join("").trimEnd()}…` : dong;
}
